export const toBase64 = (file: File) =>
  new Promise<string>((resolve, reject) => {
    console.log(file.type);
    const reader = new FileReader();
    reader.onload = () => resolve((reader.result as string).split(",")[1]);
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });

export const fromBase64 = (fileData: string, name: string, type: string) => {
  return new File([fileData], name, { type: "application/pdf" });
};

export const validateMod10 = (v: string): boolean => {
  let r,
    i,
    a = v.replace(/[^\d]/g, "").split("").map(Number),
    s = 0,
    m = 1;

  for (i = a.length - 1; i >= 0; --i) {
    if ((m ^= 1)) {
      if ((a[i] *= 2) > 9) {
        a[i] -= 9;
      }
    }
    s += a[i];
  }

  if ((r = 10 - (s % 10)) === 10) {
    r = 0;
  }

  return r === 0;
};

export const validateMod11 = (number: string): boolean => {
  if (number.length !== 11) {
    return validateNorwegianOrgNumber(number);
  } else {
    return validateNorwegianSSN(number);
  }
};

const validateNorwegianOrgNumber = (orgNum: string): boolean => {
  // Strip out anything that's not a digit
  const digits = orgNum.replace(/\D/g, "");
  // Must be exactly 9 digits
  if (digits.length !== 9) return false;

  // The check digit is the last digit
  const checkDigit = parseInt(digits.charAt(8), 10);

  // The weights to apply to the first 8 digits
  const weights = [3, 2, 7, 6, 5, 4, 3, 2];

  let sum = 0;
  for (let i = 0; i < 8; i++) {
    const digit = parseInt(digits.charAt(i), 10);
    sum += digit * weights[i];
  }

  const remainder = sum % 11;
  let calculatedCheck = 11 - remainder;

  if (calculatedCheck === 11) {
    calculatedCheck = 0;
  } else if (calculatedCheck === 10) {
    // 10 means there's no valid check digit
    return false;
  }

  return calculatedCheck === checkDigit;
};

const validateNorwegianSSN = (ssn: string): boolean => {
  console.log("Validating accountnumber: ", ssn);
  const digits = ssn.replace(/\D/g, "");
  // Must be exactly 11 digits
  if (digits.length !== 11) {
    return false;
  }

  const d = digits.split("").map((x) => parseInt(x, 10));

  // K1 = 10th digit, K2 = 11th digit
  const K1 = d[9];
  const K2 = d[10];

  // Weights for K1
  /*const weightsK1 = [3, 7, 6, 1, 8, 9, 4, 5, 2]; // applies to d[0]..d[8]
  let sum1 = 0;
  for (let i = 0; i < 9; i++) {
    sum1 += d[i] * weightsK1[i];
  }
  let calcK1 = 11 - (sum1 % 11);
  if (calcK1 === 11) calcK1 = 0;
  if (calcK1 === 10 || calcK1 !== K1) {
    return false;
  }*/

  // Weights for K2
  const weightsK2 = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2]; // notice the 2 at the end
  let sum2 = 0;
  for (let i = 0; i < 9; i++) {
    sum2 += d[i] * weightsK2[i];
  }
  // Also multiply the newly computed K1 by the last weight (2)
  sum2 += K1 * weightsK2[9];

  let calcK2 = 11 - (sum2 % 11);
  if (calcK2 === 11) calcK2 = 0;
  if (calcK2 === 10 || calcK2 !== K2) {
    return false;
  }

  return true;
};
